/**
 * Globo Smart Product Filter replaces the theme product grid.
 * With "show matching variant" on, cards use the first available variant image
 * (Pack size charts) instead of the product featured image.
 * Force each card to show the first non-variant gallery image (产品首图).
 */
(function () {
  var hooked = false;

  function promoteLazy(img) {
    if (!img) return;
    var dataSrc = img.getAttribute('data-src');
    var dataSrcset = img.getAttribute('data-srcset');
    var src = dataSrc || '';
    if (src) {
      src = src.replace('{width}', '720');
      if (src.indexOf('//') === 0) src = 'https:' + src;
    } else if (img.getAttribute('src') && img.getAttribute('src').indexOf('data:image') !== 0) {
      src = img.getAttribute('src');
    }
    if (!src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.src = src;
    img.srcset = dataSrcset
      ? dataSrcset.replace(/\{width\}/g, '720')
      : src + ' 720w';
    img.classList.remove('gflazyload');
    img.classList.add('lazyloaded', 'gfLazyautosizes');
  }

  function preferFeaturedImage(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll
      ? scope.querySelectorAll('.spf-product-card')
      : [];

    cards.forEach(function (card) {
      var main = card.querySelector('.spf-product-card__image-main');
      if (!main) return;

      var mainVariants = (main.getAttribute('data-variants') || '').trim();
      if (!mainVariants) return;

      var images = card.querySelectorAll(
        '.spf-product-card__image:not(.spf-product-card__image-secondary)'
      );
      var featured = null;
      for (var i = 0; i < images.length; i++) {
        var variantIds = (images[i].getAttribute('data-variants') || '').trim();
        if (!variantIds) {
          featured = images[i];
          break;
        }
      }
      if (!featured || featured === main) return;

      main.classList.remove('spf-product-card__image-main');
      main.classList.add('spf-product-card__image-hidden');
      featured.classList.remove('spf-product-card__image-hidden');
      featured.classList.add('spf-product-card__image-main');
      promoteLazy(featured);
    });
  }

  function hookGlobo() {
    preferFeaturedImage(document);
    if (!window.globofilter || hooked) return;
    hooked = true;
    var prev = window.globofilter.renderProductGridCallback;
    window.globofilter.renderProductGridCallback = function () {
      if (typeof prev === 'function') prev.apply(this, arguments);
      preferFeaturedImage(document);
    };
  }

  function boot() {
    hookGlobo();
    var tries = 0;
    var timer = setInterval(function () {
      hookGlobo();
      if (++tries > 40) clearInterval(timer);
    }, 250);

    if (window.MutationObserver && document.body) {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            preferFeaturedImage(document);
            break;
          }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
